<div class="head">
  <div>
    <h4>{{ document().name || (document().tag | documentTagLabel) }}</h4>
    <div>
      <app-x-icon-button
        ariaLabel="Fermer l'aperçu du document"
        (click)="closePreview()"
      ></app-x-icon-button>
      @if (blob()) {
        <button
          matIconButton
          matTooltip="Ouvrir dans un nouvel onglet, pour l’imprimer ou y rechercher du texte"
          aria-label="Ouvrir dans un nouvel onglet"
          (click)="openInNewTab()"
          class="app-button"
        >
          <svg lucideExternalLink></svg>
        </button>
        <button
          matIconButton
          matTooltip="Télécharger le document"
          aria-label="Télécharger le document"
          (click)="download()"
          class="app-button"
        >
          <mat-icon>download</mat-icon>
        </button>
      }
    </div>
  </div>
  <app-label-value
    label="Créé le"
    [value]="document().createdAt | date: 'medium'"
    class="created-at"
  ></app-label-value>
</div>
<app-document-content-viewer
  [document]="document()"
  (blobLoaded)="blob.set($event)"
  (downloadRequested)="download()"
  (originalRequested)="openInNewTab()"
></app-document-content-viewer>
